import { render, staticRenderFns } from "./AdditionalServices.vue?vue&type=template&id=2142b3a3&scoped=true&"
import script from "./AdditionalServices.vue?vue&type=script&lang=js&"
export * from "./AdditionalServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2142b3a3",
  null
  
)

export default component.exports